import React from 'react';
import { Gauge, Settings, TrendingUp, Quote, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage, usePageMeta } from '../context/LanguageContext';
const ICONS = [<Gauge className="w-7 h-7 text-white" data-id="element-143" />, <Settings className="w-7 h-7 text-white" data-id="element-144" />, <TrendingUp className="w-7 h-7 text-white" data-id="element-145" />];
export function About() {
  const {
    t
  } = useLanguage();
  usePageMeta(t.meta.about.title, t.meta.about.description);
  const a = t.aboutPage;
  return <div className="w-full bg-white" data-id="element-146">
      {/* Section 1 — Hero */}
      <section className="w-full bg-navy pt-16 pb-24" data-id="element-147">
        <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-148">
          <h1 className="text-4xl md:text-5xl lg:text-[52px] font-poppins font-bold text-white mb-6" data-id="element-149">
            {a.heroTitle}
          </h1>
          <p className="text-blue-100 text-lg leading-relaxed max-w-2xl" data-id="element-150">
            {a.heroSubtitle}
          </p>
        </div>
      </section>

      {/* Section 2 — Company Story */}
      <section className="w-full py-20" data-id="element-151">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-152">
          {/* Left column — paragraphs */}
          <div className="space-y-6" data-id="element-153">
            {a.story.map((para, i) => <p key={i} className="text-gray-600 text-base leading-relaxed" data-id="element-154">
                {para}
              </p>)}
          </div>

          {/* Right column — testimonial card */}
          <div className="bg-[#f8f9fa] border border-borderColor rounded-2xl p-8 md:p-10 shadow-[0_2px_16px_-6px_rgba(0,0,0,0.06)]" data-id="element-155">
            <Quote className="w-8 h-8 text-brandOrange mb-6" fill="currentColor" data-id="element-156" />
            <p className="text-navy text-lg font-medium leading-relaxed mb-6" data-id="element-157">
              {a.testimonialQuote}
            </p>
            <p className="text-gray-500 text-sm" data-id="element-158">{a.testimonialAuthor}</p>
          </div>
        </div>
      </section>

      {/* Section 3 — Our Values */}
      <section className="w-full bg-[#f8f9fa] py-20" data-id="element-159">
        <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-navy text-center mb-14" data-id="element-161">
            {a.valuesHeading}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-162">
            {a.values.map((value, i) => <div key={value.title} className="bg-white border border-borderColor rounded-2xl p-8 text-center flex flex-col items-center shadow-[0_2px_16px_-6px_rgba(0,0,0,0.06)]" data-id="element-163">
                <div className="w-16 h-16 rounded-full bg-brandOrange flex items-center justify-center mb-6" data-id="element-164">
                  {ICONS[i]}
                </div>
                <h3 className="text-navy font-poppins font-bold text-xl mb-3" data-id="element-165">
                  {value.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-166">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Section 4 — Call To Action */}
      <section className="w-full bg-white py-16" data-id="element-167">
        <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-168">
          <div className="bg-navy rounded-2xl px-8 py-16 text-center" data-id="element-169">
            <h2 className="text-3xl md:text-4xl font-poppins font-bold text-white mb-4" data-id="element-170">
              {t.common.howCanWeHelp}
            </h2>
            <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-171">
              {t.common.ctaSubtitle}
            </p>
            <button className="inline-flex items-center gap-2 bg-brandOrange hover:bg-brandOrange-hover text-white px-7 py-3.5 rounded font-semibold transition-colors shadow-lg shadow-brandOrange/20" data-id="element-172">
              {t.common.requestConsulting}
              <ArrowRight className="w-4 h-4" data-id="element-173" />
            </button>
          </div>
        </div>
      </section>
    </div>;
}